export default "__VITE_ASSET__8iXeJV0W__"